var _a, _b;
import * as Bowser from 'bowser';
import { isGoogleLanguage, languageList } from '@vocably/model';
import { trimLanguage } from '@vocably/sulna';
import { promptTranslations } from './ai/promptTranslations';
import { searchConfig } from './constants';
const browser = Bowser.getParser(window.navigator.userAgent);
const isMobile = browser.is('ios') || browser.is('android');
(_a = document.getElementById('ai-page')) === null || _a === void 0 ? void 0 : _a.classList.toggle('is-mobile', isMobile);
const languageSelector = document.getElementById('language');
const queryParams = new URLSearchParams(window.location.search);
const getSourceLanguage = () => {
    var _a, _b;
    if (isGoogleLanguage(window['searchFormSourceLanguage'])) {
        return window['searchFormSourceLanguage'];
    }
    if (queryParams.has('l') && isGoogleLanguage((_a = queryParams.get('l')) !== null && _a !== void 0 ? _a : '')) {
        return queryParams.get('l');
    }
    return ((_b = localStorage.getItem(searchConfig.sourceLanguageLocalStorageKey)) !== null && _b !== void 0 ? _b : 'en');
};
const selectedLanguage = getSourceLanguage();
languageSelector.value = selectedLanguage;
const promptSnippet = document.getElementById('prompt');
const copyButton = document.getElementById('copy-button');
const selectSnippet = () => {
    const range = document.createRange();
    range.selectNodeContents(promptSnippet);
    const selection = window.getSelection();
    selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
    selection === null || selection === void 0 ? void 0 : selection.addRange(range);
};
promptSnippet.addEventListener('click', selectSnippet);
const copyLabel = copyButton.querySelector('[data-copy-label]');
let copyResetTimeout;
copyButton.addEventListener('click', (e) => {
    e.stopPropagation();
    selectSnippet();
    navigator.clipboard.writeText(promptSnippet.innerText);
    const icon = copyButton.querySelector('.bi');
    if (!icon || !copyLabel)
        return;
    icon.classList.replace('bi-copy', 'bi-check-lg');
    copyButton.classList.add('is-copied');
    copyLabel.textContent = 'Copied';
    clearTimeout(copyResetTimeout);
    copyResetTimeout = setTimeout(() => {
        icon.classList.replace('bi-check-lg', 'bi-copy');
        copyButton.classList.remove('is-copied');
        copyLabel.textContent = 'Copy prompt';
    }, 2000);
});
const changeLanguage = () => {
    const language = isGoogleLanguage(languageSelector.value)
        ? languageSelector.value
        : 'en';
    localStorage.setItem(searchConfig.sourceLanguageLocalStorageKey, language);
    const languageName = trimLanguage(languageList[language]);
    const prompt = `//////////////

When I write a message in ${languageName}, respond in ${languageName} and also evaluate my grammar and suggest improvements.

Prepend evaluation as:

## ${promptTranslations[language].grammar}

Evaluation goes here
---

## ${promptTranslations[language].response}

The rest of the response goes here.

//////////////`;
    promptSnippet.innerText = prompt;
    document
        .querySelectorAll('[data-language-string]')
        .forEach((e) => (e.textContent = languageName));
};
changeLanguage();
languageSelector.addEventListener('change', changeLanguage);
const tabsRoot = document.getElementById('ai-tabs');
const tabs = Array.from(tabsRoot.querySelectorAll('[data-ai-tab]'));
const panels = Array.from(tabsRoot.querySelectorAll('[data-ai-panel]'));
const selectTab = (name, focus = false) => {
    tabs.forEach((tab) => {
        const isSelected = tab.dataset.aiTab === name;
        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.tabIndex = isSelected ? 0 : -1;
        if (isSelected && focus) {
            tab.focus();
        }
    });
    panels.forEach((panel) => {
        panel.hidden = panel.dataset.aiPanel !== name;
    });
};
tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => { var _a; return selectTab((_a = tab.dataset.aiTab) !== null && _a !== void 0 ? _a : ''); });
    tab.addEventListener('keydown', (e) => {
        var _a;
        const offset = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : undefined;
        if (offset === undefined)
            return;
        e.preventDefault();
        const next = tabs[(index + offset + tabs.length) % tabs.length];
        selectTab((_a = next.dataset.aiTab) !== null && _a !== void 0 ? _a : '', true);
    });
});
const requestedTab = ((_b = queryParams.get('ai')) !== null && _b !== void 0 ? _b : '').toLowerCase();
selectTab(tabs.some((tab) => tab.dataset.aiTab === requestedTab)
    ? requestedTab
    : 'chatgpt');
